import React, { useEffect } from 'react';
import { AppState } from '../store/configureStore';
import { Dispatch,bindActionCreators, AnyAction } from 'redux';
import { dcrActionCreators } from '../store/DCRStore';
import { connect } from 'react-redux';

interface CheckIntervalData {
    checkIntervalTime: number;
}

type TSessionCheckProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const XSPSessionCheck = function (props: TSessionCheckProps) {
    const { checkIntervalData,checkXSPSession } = props;

    useEffect(() => {
        const intervalSessionCheck = setInterval(() => {
                checkXSPSession();
        }, checkIntervalData.checkIntervalTime);
        return () => clearInterval(intervalSessionCheck);
      });

      useEffect(() => {
        const intervalUpdateSession = setInterval(() => {
                props.updateXSPSession();
        }, checkIntervalData.checkIntervalTime);
        return () => clearInterval(intervalUpdateSession);
      });

    return(<></>);
}


function mapStateToProps(state: AppState, ownProps: CheckIntervalData) {
    return {
        checkIntervalData: ownProps,
        dcr: state.dcr
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...dcrActionCreators }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(XSPSessionCheck);